import { Input, Textarea } from "../../../../../../components"
import { Controller, useFormContext } from "react-hook-form"
import type { DataList } from "../../types"
import { menuTitle } from "../ChildItem/components/Item/components/MenuTitle"

export function FormSection(props: {
  isDetail?: boolean
  isUpdate?: boolean
  action?: string
}) {

  const { control } = useFormContext<DataList>()

  return (
    <section>
      <Controller
        control={control}
        name="magister_code"
        render={({ field, fieldState }) => <Input {...field} label="CODE" error={fieldState.error?.message} value={field.value ?? ""} disabled={props.action === "DETAIL" || props.action === "DELETE"} />}
      />

      <Controller
        control={control}
        name="magister_name"
        render={({ field, fieldState }) => <Input {...field} label={menuTitle.title} error={fieldState.error?.message} value={field.value ?? ""} disabled={props.action === "DETAIL" || props.action === "DELETE"} />}
      />

      <Controller
        control={control}
        name="description"
        render={({ field, fieldState }) => <Textarea {...field} label="DESCRIPTION" error={fieldState.error?.message} value={field.value ?? ""} disabled={props.action === "DETAIL" || props.action === "DELETE"} />}
      />
    </section>
  )
}